export const styles = {
  container: 'tw-w-1/2 tw-bg-white tw-rounded-md tw-border tw-border-neutral-200 tw-shadow-sm tw-overflow-hidden tw-transition-all tw-duration-300 tw-ease-in-out',
  header: 'tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 tw-border-b tw-border-neutral-200 tw-bg-neutral-50',
  title: 'tw-text-lg tw-font-semibold tw-text-neutral-800 tw-m-0',
  content: 'tw-p-4',
  fieldContainer: 'tw-grid tw-grid-cols-2 tw-gap-4',
  closeIcon: 'tw-w-5 tw-h-5',
  stateContainer: 'tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12 tw-text-center',
  stateMessage: 'tw-text-neutral-600 tw-mb-4',
  actionsContainer: 'tw-mt-6 tw-pt-4 tw-border-t tw-border-neutral-100',
};
